import { defineStore } from 'pinia';

import { FerryEndpoint } from '../api/ferry';
import { injectStrict } from '../helpers/injectStrict';
import { RecipeStateKey } from '../state/state';

export const useStaticDataStore = defineStore('StaticDataStore', () => {
  const recipeState = injectStrict(RecipeStateKey);

  // Actions
  function setAllowMultipleVehiclesToFerryIngredients(): void {
    const ferryEndpoint = new FerryEndpoint();
    recipeState.ferryOnlyRecipe.value.forEach((ferryIngredient) => {
      if (ferryIngredient.fromPort && ferryIngredient.toPort) {
        ferryEndpoint
          .getFerryRouteStaticInfo(
            ferryIngredient.fromPort,
            ferryIngredient.toPort
          )
          .subscribe((ferryRoute) => {
            if (ferryRoute) {
              ferryIngredient.setAllowMultipleVehicles(
                ferryRoute.allowMultipleVehicles
              );
              ferryIngredient.setAllowVehicles(ferryRoute.allowVehicles);
              ferryIngredient.setPortCountry(
                ferryRoute.from.country,
                ferryRoute.to.country
              );
            }
          });
      }
    });
  }

  return {
    // Actions
    setAllowMultipleVehiclesToFerryIngredients,
  };
});
